import React from 'react';
import Auxiliary from '../../util/Auxiliary';
import Title from '../../components/Title/Title';

const About = () => {
  return (
    <Auxiliary>
      <Title>Tentang Kami</Title>
      <div className="gx-mt-3">
        QHSE PASS (QHSE Passport System) muncul sebagai jawaban atas tantangan dual disruption yaitu megatrend 2030 dan pandemic Covid-19 dimana sistem ini memiliki fungsi untuk memastikan, memantau,
        dan mengendalikan status kesiapan pekerja sebelum memasuki area kerja baik secara: <br />
        <ul>
          <li>Kompetensi</li>
          <li>Record Kepatuhan QHSE</li>
          <li>Kesehatan</li>
        </ul>
        yang mampu terintegrasi dengan sistem eksisting yang telah dimiliki PT. PP Persero (Tbk) sehingga pengelolaan big data dan analisa pekerja serta tren pelanggaran untuk Continous Improvement seluruh proyek bisa dikendalikan dengan baik.
      </div>
    </Auxiliary>
  );
}

export default About;